var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateMaterialAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attachment",
    "data-name": "Icon material-attachment",
    d: "M3,16a5.5,5.5,0,0,1,5.5-5.5H19a4,4,0,1,1,0,8H10.5a2.5,2.5,0,0,1,0-5H18v2H10.41c-.55,0-.55,1,0,1H19a2,2,0,1,0,0-4H8.5a3.5,3.5,0,1,0,0,7H18v2H8.5A5.5,5.5,0,0,1,3,16Z",
    transform: "translate(-3 -10.5)",
    fill: "#3d7cc9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateMaterialAttachment);
export default __webpack_public_path__ + "static/media/private-material-attachment.1d8f0945b41d1ee2a48d9d5d48baeed9.svg";
export { ForwardRef as ReactComponent };